import React from 'react';
import {Stack, Typography} from '@mui/material';
import EntityTagChips from './EntityTagChips';

/** Uppercase section label used across ICR / EEI / IIR / CT / CM / Gap / FINTEL tag blocks. */
export const TAGS_SECTION_HEADING_SX = {
    color: 'text.secondary',
    fontSize: '0.75rem',
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
};

/**
 * Canonical TAGS block: section header + active tags row (+ suggested tags when editable).
 * Wraps {@link EntityTagChips} so all requirement / collection modules share the same UI.
 */
export default function EntityTagsSection({
    entityType,
    entityId,
    canEdit = false,
    enabled = true,
    showHeading = true,
    showSuggestions = true,
    dense = false,
}) {
    if (!enabled || !entityId) return null;

    return (
        <Stack spacing={1} sx={{width: '100%', minWidth: 0}}>
            {showHeading && (
                <Typography sx={TAGS_SECTION_HEADING_SX}>Tags</Typography>
            )}
            <EntityTagChips
                entityType={entityType}
                entityId={entityId}
                canEdit={canEdit}
                enabled={enabled}
                dense={dense}
                showSuggestions={showSuggestions}
            />
        </Stack>
    );
}
